export const expectationsData = [
    {
        name: 'UNDERSTAND YOUR RESULTS',
        description: 'This report provides a summary of the teams results from the engagement survey.</br>To explore all dimensions, drill down into the relevant sections of the results to gain further insight.'
    },
    {
        name: 'TEST',
        description: 'In a professional context it often happens that private or corporate clients corder a publication to be made and presented with the actual content still not being ready.</br>Think of a news blog that\'s filled with content hourly on the day of going live.'
    },
    {
        name: 'REVIEW AND REFLECT',
        description: 'Review your teams results</br>Explore how well you are demonstrating leadership behaviours and expectations via indexes.'
    }, 
    {
        name: 'OPENLY SHARE YOUR RESULTS',
        description: 'In the next few weeks share the results with your team and ask open questions to gain more insight.</br>Agree with your tem what yu can do as a group.</br>'
    },
    {
        name: 'IDENTIFY AND IMPLEMENT ACTIONS',
        description: 'Identify 2-3 actions that matter most to your team</br>Inform management about the priorities and actions agreed upon by the team</br>Implement and regularly track progress.'
    },
    {
        name: 'COMMUNICATE REGULARLY',
        description: 'It\'s critical to discuss engagement regularly with your team to ensure they understand that it\'s a priority all year, not just when the survey is conducted</br>Sharing regular messages that "you said x, and we\'er doing Y" will ensure your team know you are together action on their feedback.'
    }
];



// WEBPACK FOOTER //
// ./components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/Data/expectationsData.js